<div class="heading">
  <div>
    <h2>نمودار هم‌زمان سرعت و ولتاژ</h2>
    <p>مقیاس ولتاژ برای هر خودرو و روز به‌صورت خودکار تنظیم می‌شود</p>
  </div>
  <div class="controls" *ngIf="hasData" aria-label="کنترل نمودار">
    <button type="button" (click)="zoom(1.25)" aria-label="بزرگ‌نمایی کمتر" title="بزرگ‌نمایی کمتر">−</button>
    <button type="button" (click)="resetZoom()">نمایش کل روز</button>
    <button type="button" (click)="zoom(0.8)" aria-label="بزرگ‌نمایی بیشتر" title="بزرگ‌نمایی بیشتر">+</button>
    <button type="button" [class.active]="mode === 'both'" [attr.aria-pressed]="mode === 'both'" (click)="setMode('both')">هر دو</button>
    <button type="button" [class.active]="mode === 'voltage'" [attr.aria-pressed]="mode === 'voltage'" (click)="setMode('voltage')">ولتاژ</button>
    <button type="button" [class.active]="mode === 'speed'" [attr.aria-pressed]="mode === 'speed'" (click)="setMode('speed')">سرعت</button>
  </div>
</div>
<div class="legend" aria-label="راهنمای نمودار">
  <span><i class="speed-line" aria-hidden="true"></i>سرعت (km/h) ـ محور چپ</span>
  <span><i class="voltage-line" aria-hidden="true"></i>ولتاژ (V) ـ محور راست</span>
</div>
<div *ngIf="hasData; else empty" echarts [options]="options" [autoResize]="true"
  (chartInit)="chart = $event" (chartDataZoom)="updateTimeAxis()" class="timeline-chart" dir="ltr"></div>
<ng-template #empty>
  <div class="empty" role="status">دادهٔ معتبری برای نمایش نمودار سرعت و ولتاژ موجود نیست.</div>
</ng-template>
<p class="hint" *ngIf="hasData">برای زوم از چرخ موس یا نوار پایین نمودار استفاده کنید؛ با کشیدن نمودار به چپ و راست جابه‌جا شوید. دکمه «نمایش کل روز» زوم را بازنشانی می‌کند.</p>
